import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmt } from "@/data/vaseisFields";

const toBase64 = (buf) => {
  let s = "";
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(s);
};

async function loadFonts(doc) {
  const [reg, bold] = await Promise.all(
    ["LiberationSans-Regular.ttf", "LiberationSans-Bold.ttf"].map((f) => fetch(`/fonts/${f}`).then((r) => r.arrayBuffer()).then(toBase64))
  );
  doc.addFileToVFS("Lib-Regular.ttf", reg);
  doc.addFont("Lib-Regular.ttf", "Lib", "normal");
  doc.addFileToVFS("Lib-Bold.ttf", bold);
  doc.addFont("Lib-Bold.ttf", "Lib", "bold");
}

export async function exportVaseisPdf({ field, rows, moriaFor }) {
  const my = (s) => (moriaFor ? moriaFor(s) : null);
  const reachedRows = rows.filter((s) => my(s) != null && my(s) >= s.b).length;
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  await loadFonts(doc);
  doc.setFont("Lib", "bold");
  doc.setFontSize(16);
  doc.text(`Βάσεις 2026 — ${field.short}`, 14, 16);
  doc.setFont("Lib", "normal");
  doc.setFontSize(10);
  doc.text(field.name, 14, 22);
  doc.setFontSize(8);
  doc.setTextColor(110);
  const sub = moriaFor
    ? `Μόρια υποψηφίου ανά σχολή (επίσημοι συντελεστές βαρύτητας 2026) · Σχολές που «πιάνεις»: ${reachedRows} από ${rows.length}`
    : `ΓΕΛ Ημερήσια — Γενική Σειρά 90% · ${rows.length} σχολές`;
  doc.text(sub, 14, 27);
  doc.text("Κλικ στο όνομα Τμήματος → ιστοσελίδα Τμήματος · κλικ στον κωδικό → οδηγός σπουδών & επαγγελματικά δικαιώματα (sep4u.gr)", 14, 30.5);
  doc.setTextColor(0);

  autoTable(doc, {
    startY: 34,
    head: [[ "#", "Σχολή / Τμήμα", "Ίδρυμα", "Κωδ.", ...(moriaFor ? ["Μόριά σου"] : []), "Βάση 2026", "Βάση 2025", "Διαφ.", "Θέσεις"]],
    body: rows.map((s, i) => [i + 1, s.j?.length ? `${s.n}\n→ ${s.j.join(" · ")}` : s.n, s.i, s.c, ...(moriaFor ? [fmt(my(s))] : []), fmt(s.b), fmt(s.p), s.p == null ? "—" : `${s.b - s.p > 0 ? "+" : ""}${fmt(s.b - s.p)}`, fmt(s.s)]),
    styles: { font: "Lib", fontSize: 7.5, cellPadding: 1.6, overflow: "linebreak" },
    headStyles: { fillColor: [10, 26, 74], textColor: 255, font: "Lib", fontStyle: "bold" },
    alternateRowStyles: { fillColor: [245, 246, 250] },
    columnStyles: moriaFor
      ? { 0: { cellWidth: 8, halign: "right" }, 1: { cellWidth: 60 }, 2: { cellWidth: 26 }, 3: { cellWidth: 12 }, 4: { cellWidth: 17, halign: "right" }, 5: { cellWidth: 17, halign: "right", fontStyle: "bold" }, 6: { cellWidth: 16, halign: "right" }, 7: { cellWidth: 13, halign: "right" }, 8: { cellWidth: 13, halign: "right" } }
      : { 0: { cellWidth: 8, halign: "right" }, 1: { cellWidth: 72 }, 2: { cellWidth: 30 }, 3: { cellWidth: 12 }, 4: { cellWidth: 17, halign: "right", fontStyle: "bold" }, 5: { cellWidth: 17, halign: "right" }, 6: { cellWidth: 13, halign: "right" }, 7: { cellWidth: 13, halign: "right" } },
    didParseCell: (d) => {
      if (moriaFor && d.section === "body" && my(rows[d.row.index]) >= rows[d.row.index].b) d.cell.styles.fillColor = [220, 245, 230];
      if (d.section === "body" && d.column.index === 1 && rows[d.row.index].u) d.cell.styles.textColor = [10, 26, 74];
    },
    didDrawCell: (d) => {
      const s = d.section === "body" && rows[d.row.index];
      if (s && d.column.index === 1 && s.u) doc.link(d.cell.x, d.cell.y, d.cell.width, d.cell.height, { url: s.u });
      if (s && d.column.index === 3 && s.sep) doc.link(d.cell.x, d.cell.y, d.cell.width, d.cell.height, { url: s.sep });
    },
    didDrawPage: () => {
      const h = doc.internal.pageSize.getHeight();
      doc.setFont("Lib", "normal");
      doc.setFontSize(7);
      doc.setTextColor(120);
      doc.text("Πηγή: Υπουργείο Παιδείας, Θρησκευμάτων & Αθλητισμού (23/07/2026) · Φροντιστήριο «Φυσική Επιλογή» · fysikiepilogi.gr", 14, h - 8);
      doc.text(`Σελίδα ${doc.internal.getNumberOfPages()}`, doc.internal.pageSize.getWidth() - 14, h - 8, { align: "right" });
      doc.setTextColor(0);
    },
  });

  doc.save(`vaseis-2026-pedio-${field.id}.pdf`);
}
